<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="讲师名称：">
            <el-input v-model="query.realName" placeholder="请输入讲师名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.mobile" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="讲师等级：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in lecturerLevelOptions" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="1"></el-tab-pane>
          <el-tab-pane label="推荐讲师" name="2"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['course:lecturer:state']">批量启用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['course:lecturer:state']">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['course:lecturer:add']">新建讲师</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="讲师名称" prop="realName" align="center" >
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row,2)">{{row.realName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="sex" align="center">
          <template slot-scope="{row}">
            {{row.sex === 1?'男':(row.sex === 2?'女':'')}}
          </template>
        </el-table-column>
        <el-table-column label="头像" prop="profilePhotoMini" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.profilePhotoMini" :preview-src-list="[row.profilePhotoMini]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="形象图" prop="profilePhoto" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.profilePhoto" :preview-src-list="[row.profilePhoto]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile" align="center" />
        <el-table-column label="讲师等级" prop="levelName" align="center" />
        <el-table-column label="身份描述" prop="identityTag" align="center" />
        <el-table-column label="页面排序" prop="orderNo" align="center" />
        <el-table-column label="个人简介" prop="profileDesc" align="center" show-overflow-tooltip />
        <el-table-column label="课程数量" prop="courseCount" align="center" />
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" :active-value="true" :inactive-value="false" @change="changeSwitch(row)" v-hasPermi="['course:lecturer:state']"></el-switch>
            {{row.isEnable?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedName" align="center" />
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['course:lecturer:edit']">编辑</el-button>
            <el-button type="text" @click="handleRecommend(row)" v-hasPermi="['course:lecturer:recommend']">{{row.isRecommend?'取消推荐':'设置推荐'}}</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <lecturer-add ref="lecturerAdd" @created="doQueryList({})" :lecturerLevelOptions="lecturerLevelOptions" />
  </div>
</template>

<script>
import lecturerAdd from './add'
import lecturerApi from '@/api/course/lecturer'
import Pagination from '@/components/Pagination'
import lecturerLevelApi from '@/api/course/lecturerLevel'
export default {
  components: {
    Pagination,
    lecturerAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        realName: undefined,
        mobile: undefined,
        levelId: undefined,
        isEnable: undefined
      },
      selectItems: [],
      activeName: '1',
      lecturerLevelOptions: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getLecturerLevel()
  },
  methods: {
    handleFilter(){
      this.query = {}
      this.doQueryList({ pageNo: 1,pageSize: 10 })
    },
    getLecturerLevel() {
      lecturerLevelApi.fetchList({ pageNo: 1, pageSize: 100 }).then(({ data }) => {
        this.lecturerLevelOptions = data
      })
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.isRecommend = this.activeName === '2' ? true : undefined
      this.listLoading = true
      return lecturerApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => lecturerApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => lecturerApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, true)
      } else if (command.command === 2) {
        this.handleBatchState(ids, false)
      }
    },
    handleBatchState(ids, type) {
      let txt = type ? '确认批量启用？' : '确认批量禁用？'
      this.$common.confirm(txt).then(() => lecturerApi.setIsEnable({ ids: ids, isEnable: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      lecturerApi.setIsEnable({ ids: [row.id], isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    handleRecommend(row) {
      return this.$common.confirm(`是否确认${row.isRecommend ? '取消推荐' : '设置推荐'}`)
        .then(() => lecturerApi.setIsRecommend({ ids: [row.id], isRecommend: row.isRecommend ? false : true }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.lecturerAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow',row,type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.lecturerAdd.handleUpdate(row)
    },
    handleLog(row){
     this.$router.push("/log/log?type=60&id=" + row.id);
    }
  }
}
</script>
